<template>
  <teleport to="body">
    <div v-if="show" @click="tryClose" class="backdrop"></div>
    <transition name="dialog">
      <dialog open v-if="show" >       
        <section>
          <slot></slot>
        </section>
        <menu v-if="!fixed">
          <slot name="actions">            
              <template v-if='apply'>
              <div class="btn"><base-button-sm mode="orange" @click="tryApply" >{{apply}}</base-button-sm></div>
              </template>
              <div class="btn"><base-button-sm mode="darkblue" @click="tryClose">{{switchConfirmMent()}}</base-button-sm></div>          
          </slot>
        </menu>
      </dialog>
    </transition>
  </teleport>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: false,
    },
    fixed: {
      type: Boolean,
      required: false,
      default: false,
    },
    apply:{
      type: String,
      required: false,        
    },
    cancel:{
      type: String,
      required: false,     
    },    
  },
  emits: ["close"],
  methods: {
    switchConfirmMent(){
      if(this.cancel)
      {
        return this.cancel;
      }else{
        return '닫기';
      }
    },
    tryApply() {
      if (this.fixed) {
        return;
      }
      this.$emit("apply");
    },
    tryClose() {
      if (this.fixed) {
        return;
      }
      this.$emit("close");
    },
    tryClose2() {      
      this.$emit("fixedclose");  
      this.$emit("close");   
    },

  },
};
</script>

<style scoped>
.backdrop {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10;
}

dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height:100vh;
  z-index: 20;
  border: none;
  padding: 0;
  margin: 0;
  overflow: hidden;
  background-color: rgb(0, 0, 0);
}
.mobile_dialog{
  width:90% !important;
  left: 5%;
  top: 10vh;
}
.mobile_dialog .btn{
  width:50%;
}
menu {
  padding: 1rem;
  display: flex;
  justify-content: center;
  margin: 0;

}
menu .btn
{
  width:20%;padding:0 10px;
  height:30px;
}


menu {
  padding: 1rem;
  display: flex;
  justify-content: center;
  margin: 0;
}

.dialog-enter-from,
.dialog-leave-to {
  opacity: 0;
  transform: translateY(100%);
}

.dialog-enter-active {
  transition: all 0.3s ease-out;
}

.dialog-leave-active {
  transition: all 0.3s ease-in;
}

.dialog-enter-to,
.dialog-leave-from {
  opacity: 1;
  transform: translateY(0);
}

@media (min-width: 768px) {
  dialog {
    left: calc(50% - 20rem);
    width: 40rem;
  }
}

</style>
